import { Shimmer } from '@components';

import { Container, Title, Head } from './Resources.styles';

export const CountLoading = () => {
  return (
    <Shimmer
      style={{ height: 22, width: 22, borderRadius: 4 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

export const ResourcesLoading = () => {
  return (
    <Container>
      <Head>
        <Title>Resources</Title>
      </Head>

      <Shimmer
        style={{
          height: 40,
          width: '100%',
          borderRadius: 4,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <Shimmer
        style={{
          height: 40,
          width: '100%',
          borderRadius: 4,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <Shimmer
        style={{
          height: 40,
          width: '100%',
          borderRadius: 4,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Container>
  );
};
